import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n";

function Home() {
    const { t } = useI18n();

    return (

        <>
            <>
                <Header />
                {/* Hero Section Start */}
                <div className="hero bg-section dark-section parallaxie">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-12">
                                {/* Hero Content Start */}
                                <div className="hero-content">
                                    {/* Section Title Start */}
                                    <div className="section-title">
                                        <h3 className="wow fadeInUp">{t('pages.homeHeroH3')}</h3>
                                        <h1 className="text-anime-style-3" data-cursor="-opaque">{t('pages.homeHeroH1')}</h1>
                                        <p className="wow fadeInUp" data-wow-delay="0.2s">{t('pages.homeHeroP')}</p>
                                    </div>
                                    {/* Section Title End */}
                                    {/* Hero Button Start */}
                                    {/* <div className="hero-btn wow fadeInUp" data-wow-delay="0.4s">
                                        <a href="" className="btn-default btn-highlighted">
                                            Get Tickets Now
                                        </a>

                                    </div> */}
                                    {/* Hero Button End */}
                                </div>
                                {/* Hero Content End */}

                            </div>
                        </div>
                    </div>
                </div>
                {/* Hero Section End */}

             

                {/* About Us Section Start */}
                <div className="about-us">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-xl-6">
                                {/* About Us Images Start */}
                                <div className="about-us-images">
                                    {/* About Image Box 1 Start */}
                                    <div className="about-image-box-1">
                                        {/* About Us Image 1 Start */}
                                        <div className="about-us-img-1">
                                            <figure className="image-anime ">
                                                <img src="images/konark-img1.png" alt="" />
                                            </figure>
                                        </div>
                                        {/* About Us Image 1 End */}
                                        {/* About Us Image 2 Start */}
                                        <div className="about-us-img-2">
                                            <figure className="image-anime">
                                                <img src="images/Konark Festival 2.png" alt="" />
                                            </figure>
                                        </div>
                                        {/* About Us Image 2 End */}
                                    </div>
                                    {/* About Image Box 1 End */}
                                    {/* About Image Box 2 Start */}
                                    <div className="about-image-box-2">
                                        <div className="about-experience-box">
                                            <img src="images/icon-about-experience-box.svg" alt="" />
                                            
                                            <p>konark pathautsav</p>
                                        </div>
                                        {/* About Us Image 2 Start */}
                                        <div className="about-us-img-3">
                                            <figure className="image-anime">
                                                <img src="images/Untitled design (28).png" alt="" />
                                            </figure>
                                        </div>
                                        {/* About Us Image 2 End */}
                                    </div>
                                    {/* About Image Box 2 End */}
                                </div>
                            </div>
                            {/* About Us Images End */}
                            <div className="col-xl-6">
                                {/* About Us Content Start */}
                                <div className="about-us-content">
                                    {/* Section Title Start */}
                                    <div className="section-title">
                                        <h3 className="wow fadeInUp">{t('nav.about')}</h3>
                                        <h2 className="text-anime-style-3" data-cursor="-opaque">
                                            Witness The Magic of Odisha's Cultural Spirit
                                        </h2>
                                        <p className="wow fadeInUp" data-wow-delay="0.2s">
                                            Konark Patha Utsav is a vibrant street festival that celebrates the soul of Konark through art, music, dance, and cuisine. We aim to create an unforgettable experience where tradition meets festivity.
                                        </p>
                                    </div>
                                    {/* Section Title End */}

                                    <div className="about-us-list-box">
                                        <div className="about-us-list wow fadeInUp" data-wow-delay="0.6s">
                                            <ul>
                                                <li>Built for Fun-Lovers of All Ages</li>
                                                <li>Innovation That Elevates Every Visit</li>
                                                <li>A Celebration of Joy, Culture &amp; Community</li>
                                            </ul>
                                        </div>
                                        <div className="year-experience-circle">
                                            <img src="images/year-experience-circle.svg" alt="" />
                                        </div>
                                    </div>
                                    {/* About Us Button Start */}
                                    <div className="about-us-btn wow fadeInUp" data-wow-delay="0.8s">
                                        <Link to="/About" className="btn-default">
                                            {t('pages.aboutBtn')}
                                        </Link>
                                    </div>
                                    {/* About Us Button End */}
                                </div>
                                {/* About Us Content End */}
                            </div>
                        </div>
                    </div>
                </div>
                {/* About Us Section End */}


                {/* Our Services Section Start */}
                <div className="our-services bg-section">
                    <div className="container">
                        <div className="row section-row">
                            <div className="col-lg-12">
                                {/* Section Title Start */}
                                <div className="section-title section-title-center">
                                    <h3 className="wow fadeInUp">Our Facilities </h3>
                                    <h2 className="text-anime-style-3" data-cursor="-opaque">
                                        We Ensure Comfort and Convenience at Every Step

                                    </h2>
                                </div>
                                {/* Section Title End */}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-3 col-md-6">
                                {/*  Service Item Start */}
                                <div className="service-item service-box-1 wow fadeInUp">
                                    {/* Service Item Header Start */}
                                    <div className="service-item-header">
                                        <div className="service-item-no">
                                            <h3>01</h3>
                                        </div>
                                        {/* Service Image Start */}
                                        <div className="service-image">
                                            <a href="service-single.html" data-cursor-text="View">
                                                <figure>
                                                    <img src="images/service-1.jpg" alt="" />
                                                </figure>
                                            </a>
                                        </div>
                                        {/* Service Image End */}
                                    </div>
                                    {/* Service Item Header End */}
                                    {/* Service Item Content Start */}
                                    <div className="service-item-content">
                                        <h3>
                                            <a href="service-single.html">Clean and Accessible Restrooms</a>
                                        </h3>
                                        <p>Conveniently located throughout the event area with regular maintenance and accessibility features for all guests.</p>
                                    </div>
                                    {/* Service Item Content End */}
                                </div>
                                {/* Service Item End */}
                            </div>
                            <div className="col-lg-3 col-md-6">
                                {/*  Service Item Start */}
                                <div
                                    className="service-item service-box-2 wow fadeInUp"
                                    data-wow-delay="0.2s"
                                >
                                    {/* Service Item Header Start */}
                                    <div className="service-item-header">
                                        <div className="service-item-no">
                                            <h3>02</h3>
                                        </div>
                                        {/* Service Image Start */}
                                        <div className="service-image">
                                            <a href="service-single.html" data-cursor-text="View">
                                                <figure>
                                                    <img src="images/service-2.jpg" alt="" />
                                                </figure>
                                            </a>
                                        </div>
                                        {/* Service Image End */}
                                    </div>
                                    {/* Service Item Header End */}
                                    {/* Service Item Content Start */}
                                    <div className="service-item-content">
                                        <h3>
                                            <a href="service-single.html">Food and Beverage Stalls</a>
                                        </h3>
                                        <p>Enjoy a variety of authentic regional delicacies, refreshing drinks, and snack options catering to diverse tastes and dietary needs.
                                        </p>
                                    </div>
                                    {/* Service Item Content End */}
                                </div>
                                {/* Service Item End */}
                            </div>
                            <div className="col-lg-3 col-md-6">
                                {/*  Service Item Start */}
                                <div
                                    className="service-item service-box-3 wow fadeInUp"
                                    data-wow-delay="0.4s"
                                >
                                    {/* Service Item Header Start */}
                                    <div className="service-item-header">
                                        <div className="service-item-no">
                                            <h3>03</h3>
                                        </div>
                                        {/* Service Image Start */}
                                        <div className="service-image">
                                            <a href="service-single.html" data-cursor-text="View">
                                                <figure>
                                                    <img src="images/service-3.jpg" alt="" />
                                                </figure>
                                            </a>
                                        </div>
                                        {/* Service Image End */}
                                    </div>
                                    {/* Service Item Header End */}
                                    {/* Service Item Content Start */}
                                    <div className="service-item-content">
                                        <h3>
                                            <a href="service-single.html">Food Courts Stations</a>
                                        </h3>
                                        <p>Multiple dining options featuring local, global treats</p>
                                    </div>
                                    {/* Service Item Content End */}
                                </div>
                                {/* Service Item End */}
                            </div>
                            <div className="col-lg-3 col-md-6">
                                {/*  Service Item Start */}
                                <div
                                    className="service-item service-box-4 wow fadeInUp"
                                    data-wow-delay="0.6s"
                                >
                                    {/* Service Item Header Start */}
                                    <div className="service-item-header">
                                        <div className="service-item-no">
                                            <h3>04</h3>
                                        </div>
                                        {/* Service Image Start */}
                                        <div className="service-image">
                                            <a href="service-single.html" data-cursor-text="View">
                                                <figure>
                                                    <img src="images/service-4.jpg" alt="" />
                                                </figure>
                                            </a>
                                        </div>
                                        {/* Service Image End */}
                                    </div>
                                    {/* Service Item Header End */}
                                    {/* Service Item Content Start */}
                                    <div className="service-item-content">
                                        <h3>
                                            <a href="service-single.html">Information and Help Desks</a>
                                        </h3>
                                        <p>Friendly staff at multiple points to assist with event information, lost & found, and general queries.</p>
                                    </div>
                                    {/* Service Item Content End */}
                                </div>
                                {/* Service Item End */}
                            </div>
                        </div>
                    </div>
                </div>
                {/* Our Services Section End */}







                {/* About Us Section Start */}
                <div className="about-us-gold" id="about-us">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-6">
                                {/* About Us Images Start */}
                                <div className="about-us-images-gold">
                                    {/* About Image Counter Start */}
                                    <div className="about-image-counter-gold">
                                        {/* About Image Start */}
                                        <div className="about-img-1-gold">
                                            <figure className="image-anime ">
                                                <img src="images/Media (3).jpg" alt="" />
                                            </figure>
                                        </div>
                                        {/* About Image End */}
                                        {/* About Counter Box Start */}
                                        <div className="about-counter-box-gold">
                                            <div className="about-counter-header-gold">
                                                
                                                <p>The Rio Festival, Brazil</p>
                                            </div>
                                            <div className="about-counter-body-gold">
                                                <a href="">
                                                    <img src="images/Media (2).jpg" alt="" />
                                                </a>
                                            </div>
                                           
                                        </div>
                                        {/* About Counter Box End */}
                                    </div>
                                    {/* About Image Counter End */}
                                    {/* About Image Start */}
                                    <div className="about-img-2-gold">
                                        <figure className="image-anime">
                                            <img src="images/Media (1).jpg" alt="" />
                                        </figure>
                                    </div>
                                    {/* About Image End */}
                                </div>
                                {/* About Us Images End */}
                            </div>
                            <div className="col-lg-6">
                                {/* About Us Content Start */}
                                <div className="about-us-content-gold">
                                    {/* Section Title Start */}
                                    <div className="section-title">
                                        <h3 className="wow fadeInUp"> Global Street Festivals</h3>
                                        <h2 className="text-anime-style-3" data-cursor="-opaque">
                                            More Such Street Festivals Around the World
                                        </h2>
                                        <br></br>
                                        <div class="post-entry">
                                            <blockquote className="wow fadeInUp" data-wow-delay="0.4s">
                                                <p>
                                                    In the melody of every street celebration lies the harmony of a community bound by love and tradition,{" "}
                                                </p>
                                            </blockquote>
                                        </div>

                                        <p className="wow fadeInUp" data-wow-delay="0.2s">
                                            Across the globe, vibrant street festivals light up cities and towns with the same spirit that fuels Konark Patha Utsav. These celebrations bring communities together in joyful harmony, reminding us that culture has no borders.
                                        </p>

                                    </div>
                                    {/* Section Title End */}
                                       <p className="wow fadeInUp" data-wow-delay="0.2s"> Rio Festival, held annually in Rio de Janeiro, Brazil, is the world’s largest and most famous carnival, with origins dating back to 1723. It evolved from Portuguese colonial festivities called Entrudo, where people engaged in playful street games and masquerades before Lent. </p>

                                </div>
                                {/* About Us Content End */}
                            </div>
                        </div>
                    </div>
                </div>
                {/* About Us Section End */}

                        {/* Our Facts Section Start */}
                        <div className="our-facts-gold">
                            <div className="container">
                            <div className="row section-row">
                             
                            </div>
                            <div className="row">
                                <div className="col-lg-12">
                                {/* Our Fact Box Start */}
                                <div className="our-fact-box-gold">
                                    {/* Fact Box 1 Start */}
                                    <div className="fact-box-1-gold">
                                    {/* Fact Item Start */}
                                    <div className="fact-item-gold">
                                        <div className="icon-box">
                                        <img src="images/icon-fact-item-1-gold.svg" alt="" />
                                        </div>
                                        <div className="fact-item-content-gold">
                                        <h2>
                                            <span className="counter">Mardi Gras </span>New Orleans
                                        </h2>
                                        <p>Mardi Gras in New Orleans is a centuries-old celebration with deep historic and cultural significance. Originating from medieval European traditions, Mardi Gras refers to "Fat Tuesday" in French. It is celebrated to mark the last day of feasting before the Christian season of Lent begins.</p>
                                        </div>
                                    </div>
                                    {/* Fact Item End */}
                                    {/* Fact Image Start */}
                                    <div className="fact-image-gold">
                                        <figure className="image-anime ">
                                        <img src="images/Media (10).jpg" alt="" />
                                        </figure>
                                    </div>
                                    {/* Fact Image End */}
                                    </div>
                                    {/* Fact Box 1 End */}
                                    {/* Fact Box 2 Start */}
                                    <div className="fact-box-2-gold">
                                    {/* Fact Image Start */}
                                    <div className="fact-image-gold">
                                        <figure className="image-anime ">
                                        <img src="images/Media (8).jpg" alt="" />
                                        </figure>
                                    </div>
                                    {/* Fact Image End */}
                                    </div>
                                    {/* Fact Box 2 End */}
                                    {/* Fact Box 3 Start */}
                                    <div className="fact-box-3-gold">
                                    {/* Fact Image Start */}
                                    <div className="fact-image-gold">
                                        <figure className="image-anime ">
                                        <img src="images/Media (4).jpg" alt="" />
                                        </figure>
                                    </div>
                                    {/* Fact Image End */}
                                    {/* Fact Image Content Start */}
                                    <div className="fact-image-content-gold">
                                        {/* Fact Item Start */}
                                        <div className="fact-item-gold fact-dark-box-gold">
                                        <div className="icon-box">
                                            <img src="images/icon-fact-item-2-gold.svg" alt="" />
                                        </div>
                                        <div className="fact-item-content-gold">
                                            <h2>
                                            <span className="counter">Carnival of Venice </span>Italy
                                            </h2>
                                            <p>The Carnival of Venice, Italy, is renowned for its elaborate masks and rich cultural traditions. Its origins trace back to the Middle Ages, with the first official mention in 1094 and becoming a public holiday in 1296. The carnival gives an opportunity to people from all classes to wear masks and enjoy freedom from social boundaries</p>
                                        </div>
                                        </div>
                                        {/* Fact Item End */}
                                        {/* Fact Image Start */}
                                        <div className="fact-image-gold">
                                        <figure className="image-anime ">
                                            <img src="images/Media (5).jpg" alt="" />
                                        </figure>
                                        </div>
                                        {/* Fact Image End */}
                                    </div>
                                    {/* Fact Image Content End */}
                                    </div>
                                    {/* Fact Box 3 End */}
                                </div>
                                {/* Our Fact Box End */}
                                </div>
                            </div>
                            </div>
                        </div>
                        {/* Our Facts Section End */}




                {/* CTA Box Section Start */}
                <div className="cta-box-section bg-section">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-12">
                                {/* CTA Box Start */}
                                <div className="cta-box">
                                    {/* CTA Box Content Start */}
                                    <div className="cta-box-content">
                                        {/* Section Title Start */}
                                        <div className="section-title">
                                            <h3 className="wow fadeInUp">Let’s Connect and Celebrate Together
                                            </h3>
                                            <h2 className="text-anime-style-3" data-cursor="-opaque">
                                                Your thoughts, ideas, and enthusiasm will make this celebration even bigger!

                                            </h2>
                                            <p className="wow fadeInUp" data-wow-delay="0.2s">
                                                We’d love to hear from you! Whether you’re a visitor, participant, or partner, reach out and be a part of Konark Patha Utsav.

                                            </p>
                                        </div>
                                        {/* Section Title End */}

                                    </div>
                                    {/* CTA Box Content End */}
                                    {/* CTA Box Image Start */}
                                    <div className="cta-box-image">
                                        <img src="images/cta-box-image.png" alt="" />
                                        <img src="images/cta-box-image.png" alt="" />
                                    </div>
                                    {/* CTA Box Image End */}
                                </div>
                                {/* CTA Box End */}
                            </div>
                        </div>
                    </div>
                </div>
                {/* CTA Box Section End */}





                {/* Our FAQs Section Start */}
                <div className="our-faqs bg-section">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-5">
                                {/* FAQs Content Start */}
                                <div className="faqs-content">
                                    {/* Section Title Start */}
                                    <div className="section-title">
                                        <h3 className="wow fadeInUp">Frequently Asked Questions</h3>
                                        <h2 className="text-anime-style-3" data-cursor="-opaque">
                                            Find All Your Answers About Konark Patha Utsav

                                        </h2>
                                        <p className="wow fadeInUp" data-wow-delay="0.2s">
                                            Your Quick Guide to Everything

                                        </p>
                                    </div>
                                    {/* Section Title End */}
                                    {/* Page CTA Box Start */}
                                    <div className="page-cta-box wow fadeInUp" data-wow-delay="0.4s">
                                        {/* Page CTA Content Start */}
                                        <div className="page-cta-content">
                                            <h3>Need Any Help? We're Here To Guide You Out!</h3>
                                            <p>Still have questions? We're here to help you!</p>
                                        </div>
                                        {/* Page CTA Content End */}
                                        {/* Page CTA Contact Item Start */}
                                        <div className="page-cta-contact-item">
                                            <div className="icon-box">
                                                <img src="images/icon-mail-white.svg" alt="" />
                                            </div>
                                            <div className="page-cta-contact-content">
                                                <p>
                                                    Email Us:{" "}
                                                    <a href="mailto:info@konarkpathautsav.com">info@konarkpathautsav.com</a>
                                                </p>
                                            </div>
                                        </div>
                                        {/* Page CTA Contact Item End */}
                                    </div>
                                    {/* Page CTA Box End */}
                                </div>
                                {/* FAQs Content End */}
                            </div>
                            <div className="col-lg-7">
                                {/* FAQ Accordion Start */}
                                <div className="faq-accordion" id="accordion">
                                    {/* FAQ Item Start */}
                                    <div className="accordion-item wow fadeInUp">
                                        <h2 className="accordion-header" id="heading1">
                                            <button
                                                className="accordion-button"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#collapse1"
                                                aria-expanded="true"
                                                aria-controls="collapse1"
                                            >
                                                Q1: When will Konark Patha Utsav be held?

                                            </button>
                                        </h2>
                                        <div
                                            id="collapse1"
                                            className="accordion-collapse collapse show"
                                            aria-labelledby="heading1"
                                            data-bs-parent="#accordion"
                                        >
                                            <div className="accordion-body">
                                                <p>
                                                    The official date for Konark Patha Utsav will be announced soon. Stay connected with us on social media for the latest updates and schedules.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    {/* FAQ Item End */}
                                    {/* FAQ Item Start */}
                                    <div className="accordion-item wow fadeInUp" data-wow-delay="0.2s">
                                        <h2 className="accordion-header" id="heading2">
                                            <button
                                                className="accordion-button collapsed"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#collapse2"
                                                aria-expanded="false"
                                                aria-controls="collapse2"
                                            >
                                                Q2: Where does the event take place?
                                            </button>
                                        </h2>
                                        <div
                                            id="collapse2"
                                            className="accordion-collapse collapse"
                                            aria-labelledby="heading2"
                                            data-bs-parent="#accordion"
                                        >
                                            <div className="accordion-body">
                                                <p>
                                                    It is celebrated on the main streets of Konark, transforming them into a vibrant cultural hub.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    {/* FAQ Item End */}
                                    {/* FAQ Item Start */}
                                    <div className="accordion-item wow fadeInUp" data-wow-delay="0.4s">
                                        <h2 className="accordion-header" id="heading3">
                                            <button
                                                className="accordion-button collapsed"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#collapse3"
                                                aria-expanded="false"
                                                aria-controls="collapse3"
                                            >
                                                Q3: Is registration required to attend Konark Pathautsav?
                                            </button>
                                        </h2>
                                        <div
                                            id="collapse3"
                                            className="accordion-collapse collapse"
                                            aria-labelledby="heading3"
                                            data-bs-parent="#accordion"
                                        >
                                            <div className="accordion-body">
                                                <p>
                                                    Registration is mandatory to receive updates on the date, time, and venue of Konark Patha Utsav. Please note, entry will not be permitted without prior registration.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    {/* FAQ Item End */}
                                    {/* FAQ Item Start */}
                                    <div className="accordion-item wow fadeInUp" data-wow-delay="0.6s">
                                        <h2 className="accordion-header" id="heading4">
                                            <button
                                                className="accordion-button collapsed"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#collapse4"
                                                aria-expanded="false"
                                                aria-controls="collapse4"
                                            >
                                                Q4: Can I participate in performances or competitions?
                                            </button>
                                        </h2>
                                        <div
                                            id="collapse4"
                                            className="accordion-collapse collapse"
                                            aria-labelledby="heading4"
                                            data-bs-parent="#accordion"
                                        >
                                            <div className="accordion-body">
                                                <p>
                                                    Yes, interested participants can register through our website under the “Events & Participation” section.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    {/* FAQ Item End */}
                                    {/* FAQ Item Start */}
                                    <div className="accordion-item wow fadeInUp" data-wow-delay="0.8s">
                                        <h2 className="accordion-header" id="heading5">
                                            <button
                                                className="accordion-button collapsed"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#collapse5"
                                                aria-expanded="false"
                                                aria-controls="collapse5"
                                            >
                                                Q5: What attractions can I expect?

                                            </button>
                                        </h2>
                                        <div
                                            id="collapse5"
                                            className="accordion-collapse collapse"
                                            aria-labelledby="heading5"
                                            data-bs-parent="#accordion"
                                        >
                                            <div className="accordion-body">
                                                <p>
                                                    Attendees can enjoy live music, dance competitions, art showcases, cultural parades, authentic food stalls, and workshops.

                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    {/* FAQ Item End */}

                                </div>
                                {/* FAQ Accordion End */}
                            </div>
                        </div>
                    </div>
                </div>
                {/* Our FAQs Section End */}


                <Footer />
            </>

        </>
    );
}

export default Home;